//helpers
import { cutText } from "helpers/test"

const MiniText = ({ text }) => {
    return (
        <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
    )
}

export default MiniText